<mat-toolbar class="subtitulo">Planejamento de Oficinas</mat-toolbar>

<div class="painel-principal" style="padding: 10px;">
    <form #formCadastro="ngForm">
        <mat-tab-group>

            <!-- DADOS ATIVIDADE -->
            <mat-tab label="OFICINA">
                <div ngModelGroup="dadosAtividade">
                    <dados-planejamento-oficina [planejamentoOficina]=planejamentoOficina
                                     [perfilAcesso]="perfilAcesso"></dados-planejamento-oficina>
                </div>
            </mat-tab>

            <!-- Ações -->
            <mat-tab label="AÇÕES">
                <div ngModelGroup="acoesAtividade">
                    <acoes-planejamento-oficina [planejamentoOficina]="planejamentoOficina"
                                   [perfilAcesso]="perfilAcesso"></acoes-planejamento-oficina>
                </div>
            </mat-tab>

            <!-- MATERIAIS DA ATIVIDADE -->
            <mat-tab label="MATERIAIS">
                <div ngModelGroup="materiaisPlanejamentosOficinas">
                    <material-planejamento-oficina [planejamentoOficina]="planejamentoOficina"></material-planejamento-oficina>
                </div>
            </mat-tab>

            <!-- MATERIAIS DA ATIVIDADE -->
            <mat-tab label="TURMAS">
                <div ngModelGroup="turmasPlanejamentosOficinas">
                    <turma-planejamento-oficina [planejamentoOficina]="planejamentoOficina"></turma-planejamento-oficina>
                </div>
            </mat-tab>

        </mat-tab-group>
    </form>


    <!-- BOTOES -->
    <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>
        <button *ngIf="!isAtualizar && mostrarBotaoCadastrar" mat-raised-button name="botaoConfirmar" fxFlex="20%"
            color="primary" [disabled]="formCadastro.invalid" (click)="cadastrar()"> Cadastrar
        </button>

        <button *ngIf="isAtualizar && mostrarBotaoAtualizar" mat-raised-button name="botaoConfirmar" fxFlex="20%"
            color="primary" [disabled]="formCadastro.invalid" (click)="atualizar()">
            Atualizar
        </button>

        <button *ngIf="mostrarBotaoLimpar()" mat-raised-button fxFlex="20%" (click)="limpar()">
            Limpar
        </button>
        <button mat-raised-button fxFlex="20%" (click)="cancelar()">
            Cancelar
        </button>
    </div>
</div>